export const LISTING_BRAND_VARIANTS = [
  { id: "rolex", match: (name) => /rolex/i.test(name) },
  { id: "ap", match: (name) => /audemars/i.test(name) },
  { id: "patek", match: (name) => /patek/i.test(name) },
];

export const getListingBrandVariant = (brandName) => {
  if (!brandName) {
    return "default";
  }

  return (
    LISTING_BRAND_VARIANTS.find((brand) => brand.match(brandName))?.id ||
    "default"
  );
};

export const getListingBrandConfig = (brandName) => {
  const variant = getListingBrandVariant(brandName);

  return {
    variant,
    label: brandName || "Watch",
  };
};
